import { render, staticRenderFns } from "./AgeVerification.vue?vue&type=template&id=145bb0dc&scoped=true"
import script from "./AgeVerification.vue?vue&type=script&lang=js"
export * from "./AgeVerification.vue?vue&type=script&lang=js"
import style0 from "./AgeVerification.vue?vue&type=style&index=0&id=145bb0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145bb0dc",
  null
  
)

export default component.exports